import makeTable from '../../components/makeTable.jsx';

export const IssueTable = makeTable([
  ['Issue', 85],
  ['Count', 15],
]);
